module.exports = __webpack_public_path__ + "img/house-of-hungarian-music.59475c4.svg";